import { render } from "./Dashboard.vue?vue&type=template&id=f873a404&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-f873a404"

export default script